import * as TYPES from "../App/App.types";
import { success, error, abort } from "@redux-requests/core";

const initialState = {
  loading: false,
  clientSecret: null,
  stripePaymentIntentId: null,
  paymentMethodType: null,
  payments: null,
  totalBalance: 0,
  payoutsLost: 0,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.SET_CLIENT_SECRET: {
      return {
        ...state,
        paymentMethodType: action.payload.paymentMethodType,
        clientSecret: action.payload.secret,
        stripePaymentIntentId: action.payload.stripePaymentIntentId
      };
    }
    case TYPES.CREATE_PAYOUT:
    case TYPES.GET_CONNECT_TO_STRIPE_LINK:
    case TYPES.CONFIRM_STRIPE_ACCOUNT:
    case TYPES.GET_PAYMENTS:
    case TYPES.CREATE_STRIPE_PAYMENT: {
      return {
        ...state,
        loading: true,
      };
    }
    case success(TYPES.CREATE_PAYOUT):
    case success(TYPES.CONFIRM_STRIPE_ACCOUNT):
    case success(TYPES.GET_CONNECT_TO_STRIPE_LINK): {
      return {
        ...state,
        loading: false,
      };
    }
    case success(TYPES.CREATE_STRIPE_PAYMENT): {
      return {
        ...state,
        paymentMethodType: action.response.data.paymentMethodType,
        clientSecret: action.response.data.clientSecret,
        stripePaymentIntentId: action.response.data.stripePaymentIntentId,
        payment: {...action.response.data.payment},
        loading: false,
      };
    }
    case success(TYPES.REDIRECT_TO_STRIPE_ACCOUNT): {
      return window.location.href = (action.response.data.link);
    }

    case success(TYPES.GET_PAYMENTS): {
      return {
        ...state,
        payments: action.response.data.payments,
        totalBalance: action.response.data.balance,
        payoutsLost: action.response.data.payoutsLost,
        loading: false,
      };
    }
    case abort(TYPES.GET_PAYMENTS):
    case abort(TYPES.CREATE_STRIPE_PAYMENT):
    case abort(TYPES.CREATE_PAYOUT):
    case abort(TYPES.GET_CONNECT_TO_STRIPE_LINK):
    case abort(TYPES.CONFIRM_STRIPE_ACCOUNT):
    case error(TYPES.CREATE_PAYOUT):
    case error(TYPES.GET_CONNECT_TO_STRIPE_LINK):
    case error(TYPES.CONFIRM_STRIPE_ACCOUNT):
    case error(TYPES.GET_PAYMENTS):
    case error(TYPES.CREATE_STRIPE_PAYMENT): {
      return {
        ...state,
        loading: true,
      };
    }
    default:
      return { ...state };
  }
};

export default reducer;
